import {
  useCreateConnection,
  useEditConnection,
} from "src/api/connectApi/queries";
import { useAllCaseVersionsCombinedWithTemplates } from "src/cases/queries/templates";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useCaseSchemaEditorState = () => {
  const { workspace } = useWorkspaceContext();
  const createConnectionMutation = useCreateConnection(workspace.base_url);
  const editConnectionMutation = useEditConnection(
    workspace.base_url,
    undefined,
  );

  const { data: templatesData, isLoading: isLoadingTemplates } =
    useAllCaseVersionsCombinedWithTemplates();

  const isCaseEditorLoading =
    createConnectionMutation.isPending || editConnectionMutation.isPending;

  return {
    createConnectionMutation,
    editConnectionMutation,
    templatesData,
    isLoadingTemplates,
    isCaseEditorLoading,
  };
};
